import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDPrimaryActionIconButton,
  FDPrimaryActionButton,
} from '@facet-wealth/design';
import Proptypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { DialogContent, DialogActions } from 'Views/Page/Content/Modal/Components';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { ErrorList2 } from 'Components/ComponentLibrary/Molecules/ErrorList2';
import { noop } from 'Helpers/PropTypes';
import { dataAttrs } from 'Helpers/Testing';
import metaOverrideSet from './metaOverrideSet';

/**
 * This modal layout wrapper is meant to be used for PX modal layouts that have a title and some form inputs. There
 * may be one or more inputs on the form.
 */
const PXFormModalWrapper = ({ children, buttonLabel, onSubmitSuccess }) => {
  const {
    onSubmit, saving, resource, errors,
  } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleContinue = async () => {
    onSubmitSuccess(await onSubmit());
  };

  return (
    <>
      <MetaControlField attr={'title'} resource={resource} metaOverrideSet={metaOverrideSet} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={3}>
          <MetaControlField attr={'subtitle'} resource={resource} metaOverrideSet={metaOverrideSet} />
          {children}
          <ErrorList2 title={'Validation errors'} errors={errors} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              {...dataAttrs('back-btn', resource)}
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        {resource.meta().canSubmit() ? <FDPrimaryActionButton {...dataAttrs('continue-btn', resource)} label={buttonLabel} onClick={handleContinue} disabled={saving} /> : null}
      </DialogActions>
    </>
  );
};

PXFormModalWrapper.defaultProps = {
  onSubmitSuccess: noop,
  buttonLabel: 'Continue →',
};

PXFormModalWrapper.propTypes = {
  onSubmitSuccess: Proptypes.func,
  children: Proptypes.any.isRequired,
  buttonLabel: Proptypes.string,
};

export default PXFormModalWrapper;
